'use strict';require('../../style/css');
require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/modal/style/css.web.js
// module id = 418
// module chunks = 0